import { render, staticRenderFns } from "./page-layout.vue?vue&type=template&id=72215dba&scoped=true&"
import script from "./page-layout.vue?vue&type=script&lang=js&"
export * from "./page-layout.vue?vue&type=script&lang=js&"
import style0 from "./page-layout.vue?vue&type=style&index=0&id=72215dba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72215dba",
  null
  
)

export default component.exports